import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import SurveyPage from '../../../../components/SurveyComponent/SurveyJson/Survey';

import api from '../../../../services/api';

import { Header, Footer } from './styles';
import { Container } from '../../../Questionnaire/styles';
import logoEb from '../../../../assets/eb-logo.svg';
import { getSplittedMatrix } from '../../../../utils/getSplittedMatrix';
import { getElementsWithoutId } from '../../../../utils/getElementsWithoutId';

interface SurveyParams {
  surveyId: string;
}

interface Logo {
  id: number;
  filePath: string;
}

interface SurveyText {
  surveyTextId: number;
  text: string;
  isStartText: boolean;
}

interface Survey {
  idSurvey: number;
  isTemplate: boolean;
  name: string;
  title: string;
  pages: object[];
  projectId: number;
  subGroup: string;
  logo: Logo;
  startText: SurveyText;
  finalText: SurveyText;
}

const Survey: React.FC = () => {
  const [survey, setSurvey] = useState<Survey>();
  const { surveyId } = useParams();

  useEffect(() => {
    api.get(`/surveys/${surveyId}`).then(response => {
      const formattedPages: any[] = [];

      if (
        response.data &&
        response.data.startText &&
        response.data.placeholders
      ) {
        response.data.placeholders.forEach((placeholder: any) => {
          response.data.startText.text = response.data.startText.text.replace(
            placeholder.searchValue,
            placeholder.replaceValue,
          );
        });
      }

      if (
        response.data &&
        response.data.completedHtml &&
        response.data.placeholders
      ) {
        response.data.placeholders.forEach((placeholder: any) => {
          response.data.completedHtml = response.data.completedHtml.replace(
            placeholder.searchValue,
            placeholder.replaceValue,
          );
        });
      }

      response.data?.pages.map((page: any) => {
        const customPages: any[] = [];
        let elementsPerPage: any[] = [];
        page.elements.map((element: any, index: number) => {
          if (response.data.placeholders) {
            response.data.placeholders.forEach((placeholder: any) => {
              if (element.type === 'matrix') {
                element?.rows?.map((x: any) => {
                  const y = x;
                  y.text = x.text.replace(
                    placeholder.searchValue,
                    placeholder.replaceValue,
                  );
                  return y;
                });

                element?.columns?.map((x: any) => {
                  const y = x;
                  y.text = x.text.replace(
                    placeholder.searchValue,
                    placeholder.replaceValue,
                  );
                  return y;
                });
              }

              const questionTitlePlaceHolder = element;

              questionTitlePlaceHolder.title = element?.title?.replace(
                placeholder.searchValue,
                placeholder.replaceValue,
              );

              if (
                questionTitlePlaceHolder &&
                questionTitlePlaceHolder.choices
              ) {
                questionTitlePlaceHolder.choices.map((x: any) => {
                  const y = x;
                  const optionTextPalceHolder: string = y.text;
                  y.text = optionTextPalceHolder.replace(
                    placeholder.searchValue,
                    placeholder.replaceValue,
                  );

                  return y;
                });
              }
            });
          }

          if (element.type !== 'matrix') {
            if (customPages.length === 0) {
              elementsPerPage.push(element);
              return element;
            }
            customPages[customPages.length - 1].elements.push(element);
            return element;
          }

          if (
            element.type === 'matrix' &&
            element?.splitMatrix &&
            element?.numberOfRowsToSplit < element?.rows?.length
          ) {
            const splittedMatrix: any = getSplittedMatrix(element);

            if (element.numberOfGroupsToInsertPageBreakAfter > 0) {
              let countAux = 1;
              for (let i = 0; i < splittedMatrix.length; i += 1) {
                if (
                  countAux === element.numberOfGroupsToInsertPageBreakAfter &&
                  i !== splittedMatrix.length - 1
                ) {
                  elementsPerPage.push({ ...splittedMatrix[i] });

                  if (
                    index === 0 ||
                    (element.numberOfGroupsToInsertPageBreakAfter - i - 1 ===
                      0 &&
                      customPages.length === 0)
                  ) {
                    customPages.push({
                      name: `page${i}_${element.matrixId}`,
                      elements: elementsPerPage,
                    });
                  } else {
                    customPages[customPages.length - 1].elements.push(
                      ...elementsPerPage,
                    );
                  }
                  countAux = 1;
                  elementsPerPage = [];
                } else if (i === splittedMatrix.length - 1) {
                  elementsPerPage.push({ ...splittedMatrix[i] });

                  customPages.push({
                    name: `page${i}_${element.matrixId}`,
                    elements: elementsPerPage,
                  });

                  elementsPerPage = [];
                } else {
                  elementsPerPage.push({ ...splittedMatrix[i] });
                  countAux += 1;
                }
              }

              return element;
            }

            elementsPerPage.push(...splittedMatrix);
            return element;
          }
          elementsPerPage.push(element);
          return element;
        });

        if (customPages.length > 0) {
          formattedPages.push(...customPages);
        } else {
          formattedPages.push({ ...page, elements: elementsPerPage });
        }

        const newPage = { ...page, elements: [] };
        return newPage;
      });

      const formattedPagesWithoudElementIds = formattedPages.map(
        (page: any) => {
          return {
            ...page,
            elements: getElementsWithoutId(page.elements),
          };
        },
      );

      const surveyTmp = {
        ...response.data,
        idSurvey: surveyId,
        pages: formattedPagesWithoudElementIds,
      };
      delete surveyTmp.surveyId;
      setSurvey(surveyTmp);
    });
  }, [surveyId]);

  return (
    <>
      <Header>
        <img src={logoEb} alt="Logo - Survey" />
      </Header>

      <Container
        $useStyle={false}
        $buttonStyle={''}
        $boxQuestionType={''}
        $mainColor={'#1AB394'}
        $showFinalMessage={false}
      >
        <SurveyPage model={survey} />
      </Container>

      <Footer />
    </>
  );
};

export default Survey;
